type DefaultProfilePicProps = {
  size?: string;
  fill?: string;
};

export default function DefaultProfilePic({
  size,
  fill,
}: DefaultProfilePicProps) {
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <path
        id="Layer"
        fillRule="evenodd"
        fill={fill ?? "#040404"}
        d="m24.1 0.1c13.2 0 23.8 10.8 23.8 23.9-0.1 13.1-10.8 23.8-23.9 23.8-13.1 0-23.8-10.7-23.9-23.8 0-13.1 10.6-23.9 23.8-23.9zm-0.6 12.1c-5.9 0.1-10.6 4.9-10.6 10.8 0 5.9 4.8 10.7 10.7 10.7 5.9 0 10.7-4.8 10.8-10.7 0-5.9-4.7-10.7-10.6-10.8zm-8.2 33c2.7 1.1 5.7 1.7 8.6 1.7 2.9 0 5.9-0.6 8.6-1.7 2.7-1.1 5.2-2.7 7.4-4.7q-3.9-4.9-9.5-4.9h-13q-5.6 0-9.5 4.9c2.2 2 4.7 3.6 7.4 4.7z"
      />
    </svg>
  );
}
